<form class="form-search-bar form-table" [formGroup]="entriesForm" (ngSubmit)="entriesSubmit()" autocomplete="off">
  <table class="kf-registration-table" mat-table [dataSource]="categories" formArrayName="entries">
    <ng-container matColumnDef="entry">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let category; let i = index" >
        {{category.description}}
        <span>Total</span>
      </td>
      <td mat-footer-cell *matFooterCellDef> Total </td>
    </ng-container>

    <ng-container matColumnDef="pieces">
      <th mat-header-cell *matHeaderCellDef>
        <div class="info">
          Pieces
          <app-help-icon-button [code]="'keyfigureentry.Pieces'"></app-help-icon-button>
        </div>
      </th>
      <td mat-cell *matCellDef="let category; let i = index" [formGroupName]="i">
        <mat-form-field appearance="outline" class="filter-item">
          <input onfocus="this.select()" class="input-number" matInput type="number" formControlName="pieces"
                 [readonly]="kfRegistrationDetail?.kfRegistration?.completionStatus"
                 (change)="sum()"
                 [mdePopoverTriggerFor]="piecesPopover"
                 mdePopoverTriggerOn="none"
                 mdePopoverArrowColor="none"
                 (click)="entriesControl.at(i).get('pieces')?.invalid ? popoverTrigger.openPopover() : null"
                 #popoverTrigger="mdePopoverTrigger"
          />
          <mde-popover #piecesPopover="mdePopover" [mdePopoverOverlapTrigger]="false" [class]="entriesControl.at(i)?.get('pieces')?.hasError('max') || entriesControl.at(i)?.get('pieces')?.hasError('min') ? '' : 'visibility-hidden'">
            <mat-card *ngIf="entriesControl.at(i)?.get('pieces')?.hasError('max') || entriesControl.at(i)?.get('pieces')?.hasError('min')">
              <mat-card-content>
                <p *ngIf="entriesControl.at(i)?.get('pieces')?.hasError('max')">
                  {{'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% higher than last year figure. Click to mark as correct'}}
                </p>
                <p *ngIf="entriesControl.at(i)?.get('pieces')?.hasError('min')">
                  {{'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% lower than last year figure. Click to mark as correct'}}
                </p>
              </mat-card-content>
              <mat-card-actions align="end">
                <button mat-raised-button type="button"  (click)="piecesPopover._emitCloseEvent()">Close</button>
                <button mat-raised-button type="button" color="primary" (click)="allowValidation('pieces', i)">Allow</button>
              </mat-card-actions>
            </mat-card>
          </mde-popover>
        </mat-form-field>
      </td>
      <td mat-footer-cell *matFooterCellDef>
        <mat-form-field appearance="outline" class="filter-item">
          <input class="input-number" matInput type="number" [readonly]="true" [value]="totalValues[0].toFixed(2)"/>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="tons">
      <th mat-header-cell *matHeaderCellDef>
        <div class="info">
          Tons
          <app-help-icon-button [code]="'keyfigureentry.Tons'"></app-help-icon-button>
        </div>
      </th>
      <td mat-cell *matCellDef="let category; let i = index" [formGroupName]="i">
        <mat-form-field appearance="outline" class="filter-item">
          <input onfocus="this.select()" class="input-number" matInput type="number" formControlName="tons"
                 [readonly]="kfRegistrationDetail?.kfRegistration?.completionStatus"
                 (change)="sum()"
                 [mdePopoverTriggerFor]="tonsPopover"
                 mdePopoverTriggerOn="none"
                 mdePopoverArrowColor="none"
                 (click)="entriesControl.at(i).get('tons')?.invalid ? popoverTrigger.openPopover() : null"
                 #popoverTrigger="mdePopoverTrigger"
          />
          <mde-popover #tonsPopover="mdePopover" [mdePopoverOverlapTrigger]="false" [class]="entriesControl.at(i)?.get('tons')?.hasError('max') || entriesControl.at(i)?.get('pieces')?.hasError('min') ? '' : 'visibility-hidden'">
            <mat-card *ngIf="entriesControl.at(i)?.get('tons')?.hasError('max') || entriesControl.at(i)?.get('tons')?.hasError('min')">
              <mat-card-content>
                <p *ngIf="entriesControl.at(i)?.get('tons')?.hasError('max')">
                  {{'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% higher than last year figure. Click to mark as correct'}}
                </p>
                <p *ngIf="entriesControl.at(i)?.get('tons')?.hasError('min')">
                  {{'The value is ' + (newKfRegistrationDetail.deviation > 0 ? newKfRegistrationDetail.deviation : kfRegistrationDetail.deviation) + '% lower than last year figure. Click to mark as correct'}}
                </p>
              </mat-card-content>
              <mat-card-actions align="end">
                <button mat-raised-button type="button"  (click)="tonsPopover._emitCloseEvent()">Close</button>
                <button mat-raised-button type="button" color="primary" (click)="allowValidation('tons', i)">Allow</button>
              </mat-card-actions>
            </mat-card>
          </mde-popover>
        </mat-form-field>
      </td>
      <td mat-footer-cell *matFooterCellDef>
        <mat-form-field appearance="outline" class="filter-item">
          <input class="input-number" matInput type="number" [readonly]="true" [value]="totalValues[1].toFixed(2)"/>
        </mat-form-field>
      </td>
    </ng-container>

    <ng-container matColumnDef="remark">
      <th mat-header-cell *matHeaderCellDef>
        <div class="info">
          Remark
          <app-help-icon-button [code]="'keyfigureentry.Remark'"></app-help-icon-button>
        </div>
      </th>
      <td mat-cell *matCellDef="let category; let i = index" [formGroupName]="i">
        <mat-form-field appearance="outline" class="filter-item">
          <input matInput type="text" formControlName="remark"
                 [readonly]="kfRegistrationDetail?.kfRegistration?.completionStatus"/>
        </mat-form-field>
      </td>
      <td mat-footer-cell *matFooterCellDef>
        <mat-form-field appearance="outline" class="filter-item">
          <input matInput type="text" [readonly]="true" value=""/>
        </mat-form-field>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
  </table>

  <p class="mat-error" *ngIf="entriesForm.invalid">
    Please correct or confirm values that are negative or different from those of the previous year - highlighted in red in the form. (Please click on cells containing values or click on Save to discover the error).
  </p>
  <div class="wizard-buttons-container align-right">
    <button mat-raised-button color="primary" type="button" #markAsCompletedButton
            *ngIf="!simpleUser"
            (click)="!markAsCompletedButton.disabled ? markAsCompleted() : ''"
            [disabled]="kfRegistrationDetail?.kfRegistration?.completionStatus || entriesForm.invalid">
      <mat-icon class="material-icons-outlined">check_circle</mat-icon>
      <span> Mark as completed</span>
    </button>
    <button mat-raised-button class="reset" type="button"
            (click)="reset()"
            *ngIf="!simpleUser"
            [disabled]="kfRegistrationDetail?.kfRegistration?.completionStatus || kfRegistrationDetail === undefined">
      <span>Reset </span>
      <mat-icon class="material-icons-outlined">refresh</mat-icon>
    </button>
    <button mat-raised-button matStepperPrevious type="button">
      <mat-icon class="material-icons-outlined">chevron_left</mat-icon>
      <span>Back</span>
    </button>
    <button mat-raised-button type="submit" color="primary"
            *ngIf="!kfRegistrationDetail?.kfRegistration?.completionStatus && !simpleUser">
      <span>Save</span>
      <mat-icon class="material-icons-outlined">chevron_right</mat-icon>
    </button>
    <button mat-raised-button type="button" color="primary"
            (click)="this.redirectUrlEmitter.emit()"
            *ngIf="kfRegistrationDetail?.kfRegistration?.completionStatus">
      <mat-icon class="material-icons-outlined">undo</mat-icon>
      <span>Return</span>
    </button>
  </div>
</form>
